import { Box, TextField } from '@mui/material'
import match from '@derolfgroep/utils/lib/autosuggest-highlight/match'
import parse from '@derolfgroep/utils/lib/autosuggest-highlight/parse'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import ConnectedAutocomplete from '../ConnectedAutocomplete/ConnectedAutocomplete'

const Option = ({ label, icon, inputValue, ...props }) => {
  const highlightedLabel = useMemo(() => {
    const matches = match(label, inputValue)
    const parts = parse(label, matches)

    return parts.map((part, index) => (
      <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
        {part.text}
      </span>
    ))
  }, [label, inputValue])

  return (
    <Box {...props} display="flex" alignItems="center">
      <Box mr={1} display="inherit">
        {icon}
      </Box>
      <Box display="block">{highlightedLabel}</Box>
    </Box>
  )
}
Option.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  inputValue: PropTypes.string,
}

const InstitutionSelectorAutocomplete = ({ options, defaultValue, onSelectInstitution }) => (
  <ConnectedAutocomplete
    namespace="institutionSelector"
    fieldName="institution"
    data-analytics="institutionSelector"
    fullWidth
    disableClearable
    autoHighlight
    id="institution-name"
    options={options}
    defaultValue={defaultValue}
    onChange={onSelectInstitution}
    renderInput={(props) => (
      <TextField {...props} required fullWidth margin="none" placeholder="Selecteer een school" />
    )}
    renderOption={(props, option, state) => <Option {...props} {...option} {...state} />}
  />
)
InstitutionSelectorAutocomplete.propTypes = {
  options: PropTypes.array.isRequired,
  onSelectInstitution: PropTypes.func,
  defaultValue: PropTypes.any,
}

export default InstitutionSelectorAutocomplete
